/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import { Modal, Tabs } from "react-bootstrap";

import { ModalContext } from "../../context/modal";
import { DefaultButton, MyModalBody } from "../../style/default";
import AdvancedConfig from "./advancedConfig";
import { Tab } from "./style";
import UserPropsConfig from "./userPropsConfig";
import { authApi } from "../../services/api";
import { toast } from "react-toastify";
import { TOASTIFY_OPTIONS } from "../../style/global";
function ModalAccountsCreate({ open, populateTable }) {
	const { handleOpenModal } = useContext(ModalContext);

	//CREATE USERPROPS CONFIG OBJECT
	const [userPropsData, setUserPropsData] = useState({});
	const [canGetUserPropsData, setGetUserPropsData] = useState(false);

	//CREATE ADVANCED CONFIG OBJECT
	const [advancedConfigData, setAdvancedConfigData] = useState({});
	const [canAdvancedConfigData, setGetAdvancedConfigData] = useState(false);

	useEffect(() => {
		if (
			Object.keys(advancedConfigData).length &&
			Object.keys(userPropsData).length
		) {
			const reqObj = {
				...userPropsData,
				...advancedConfigData,
			};
			handleEdit(reqObj);
		}
	}, [advancedConfigData]);

	const uploadProfilePhoto = async (obj) => {
		try {
			const formData = new FormData();
			formData.append("picture", obj.file);
			formData.append("_id", obj._id);
			formData.append("uploadType", "company-pic");
			await authApi.post("/account/edit", formData);
		} catch (error) {
			return;
		}
	};

	const handleEdit = async (obj) => {
		try {
			if (Object.keys(obj).length) {
				const data = await authApi.post("/account/create", obj);
				if (data.status === 200) {
					await uploadProfilePhoto({ file: obj.picture, _id: data.data.id });
					toast.success("Conta cadastrada com sucesso.", TOASTIFY_OPTIONS);
					populateTable();
					handleOpenModal();
				}
			}
		} catch (error) {
			console.log(error);
		}
	};

	return (
		<Modal show={open} onHide={handleOpenModal} size="xl" backdrop="static">
			<Modal.Header closeLabel="" closeButton>
				<Modal.Title>Cadastrar novo cliente</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<MyModalBody>
					<Tab>
						<Tabs>
							<Tabs eventKey="table" title="Configurações básicas">
								<UserPropsConfig
									updateTable={populateTable}
									setAllData={[userPropsData, setUserPropsData]}
									canGetData={[canGetUserPropsData, setGetUserPropsData]}
								/>
							</Tabs>
							<Tabs eventKey="chart" title="Configurações avançadas">
								<AdvancedConfig
									updateTable={populateTable}
									setAllData={[advancedConfigData, setAdvancedConfigData]}
									canGetData={[canAdvancedConfigData, setGetAdvancedConfigData]}
								/>
							</Tabs>
						</Tabs>
					</Tab>
				</MyModalBody>
			</Modal.Body>
			<Modal.Footer>
				<DefaultButton
					onClick={() => {
						setGetAdvancedConfigData(true);
						setGetUserPropsData(true);
					}}
				>
					Cadastrar
				</DefaultButton>
			</Modal.Footer>
		</Modal>
	);
}

export { ModalAccountsCreate };
